export const permissionGroupColNm = {
  Name: "ชื่อกลุ่มสิทธิ์",
  Rmk: "หมายเหตุ",
  IsActv: "สถานะ",
  NumMember: "จำนวนสมาชิก",
  MemberNms: "สมาชิก",
}

export const menuNames = {
  0: "สิทธิ์พิเศษ (Action)",
  1: "1. งานประจำวัน",
  2: "2. ข้อมูลงาน",
  3: "3. บัญชีและการเงิน",
  4: "4. ข้อมูลการเงิน",
  5: "5. รายงาน",
  6: "6. Admin",
  7: "7. ซ่อมบำรุง",
  8: "8. เพิ่มเติม",
  9: "9. งานบัญชี",
}

export const MODE_NONE = 0
export const MODE_READ = 1
export const MODE_EDIT = 2

export const modeNames = {
  [MODE_NONE]: "ไม่มีสิทธิ์",
  [MODE_READ]: "ดูอย่างเดียว",
  [MODE_EDIT]: "ดูและแก้ไข",
}
